const Loader = () => {
  return (
    <div className="br_loader_main active">
      <div className="br_loader_bg" />
      <div className="br_loader_content">
        <div className="br_spinner">
          <div className="spinner_inner">
            <div className="spinner_line" />
            <div className="spinner_line" />
            <div className="spinner_line" />
            <div className="spinner_circle">●</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Loader;
